module.exports = __webpack_public_path__ + "static/media/pp-logo-updated.1cd45648.png";